<template>
  <div class="login register container-fluid">
    <div class="row eq-height">
      <div class="col-lg-7 login-left">
        <div class="row mt-20 side-pad login-header">
          <div class="col-6">
            <router-link to="/dashboard">
              <img
                class="login__image"
                src="@/assets/img/bettermynd-logo@2x.png"
                alt="BetterMynd"
              />
            </router-link>
          </div>
          <div class="col-6 text-right signup-link" />
        </div>

        <div v-show="page === 1" class="login-content text-center">
          <div>
            <card page="login">
              <label v-if="hasSelectedCollege" class="top-label">COMPLETE PROFILE: STEP 1 OF 3</label>
              <label v-else class="top-label">COMPLETE PROFILE: STEP 1 OF 4</label>
              <h1>Personal Info</h1>
              <form-component>
                <form
                  id="step-one"
                  data-vv-scope="step-one"
                  novalidate="novalidate"
                  @submit.prevent="doSaveWelcomeStepOne"
                >
                  <label class="replacement-label">WHEN IS YOUR BIRTHDAY?</label>
                  <div
                    class="form-row hide-label"
                    :class="{
                      'form-wrapper__error':
                        errors.has('step-one.month') ||
                        errors.has('step-one.day') ||
                        errors.has('step-one.year')
                    }"
                  >
                    <div class="col-12 col-md-4">
                      <input-select
                        id="month"
                        v-model="month"
                        v-validate="'required'"
                        name="month"
                        data-vv-name="month"
                        data-vv-as="month"
                        label="Month"
                        type="select"
                        placeholder="Month"
                        required
                        :error="errors.first('step-one.month')"
                        :options="monthOptions"
                        :hide-error-label="true"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <input-select
                        id="day"
                        v-model="day"
                        v-validate="'required'"
                        name="day"
                        data-vv-name="day"
                        data-vv-as="day"
                        label="Day"
                        type="select"
                        placeholder="Day"
                        required
                        :error="errors.first('step-one.day')"
                        :options="dayOptions"
                        :hide-error-label="true"
                      />
                    </div>
                    <div class="col-12 col-md-4">
                      <input-select
                        id="year"
                        v-model="year"
                        v-validate="'required'"
                        name="year"
                        data-vv-name="year"
                        data-vv-as="year"
                        label="Year"
                        type="select"
                        placeholder="Year"
                        required
                        :error="errors.first('step-one.year')"
                        :options="yearOptions"
                        :hide-error-label="true"
                      />
                    </div>
                    <div class="col-12">
                      <p
                        v-show="
                          errors.has('step-one.month') ||
                            errors.has('step-one.day') ||
                            errors.has('step-one.year')
                        "
                        class="form__error"
                      >
                        The birthday field is required
                      </p>
                    </div>
                  </div>

                  <label class="replacement-label">Where are you currently located?</label>
                  <div class="form-row hide-label">
                    <div class="col-12">
                      <input-type-ahead
                        v-validate="'required'"
                        :list="cities"
                        :value="currentCity"
                        :searchchange="getCities"
                        :selected-value="selectedCity"
                        option-value="id"
                        option-text="display_name"
                        data-vv-name="currentCity"
                        data-vv-as="Current Location"
                        required
                        label="Current Location"
                        placeholder="Type a city name..."
                      />

                      <p
                        v-show="errors.first('step-one.currentCity')"
                        class="form__error"
                      >
                        {{ errors.first('step-one.currentCity') }}
                      </p>
                    </div>
                  </div>

                  <label class="replacement-label">WHAT IS YOUR GENDER IDENTITY?</label>
                  <div class="form-row hide-label">
                    <div class="col-12">
                      <gender-select
                        id="gender"
                        v-model="gender"
                        v-validate="'required'"
                        name="gender"
                        data-vv-name="gender"
                        data-vv-as="gender"
                        label="gender"
                        :select-options="counselorGenderOptions"
                        required
                        :error="errors.first('step-one.gender')"
                      />
                    </div>
                  </div>

                  <label class="replacement-label">WHAT IS YOUR ETHNICITY?</label>
                  <div class="form-row hide-label">
                    <div class="col-12">
                      <counselor-ethnicity-select
                        id="ethnicity"
                        v-model="ethnicity"
                        v-validate="'required'"
                        name="ethnicity"
                        data-vv-name="ethnicity"
                        data-vv-as="ethnicity"
                        label="ethnicity"
                        required
                        :error="errors.first('step-one.ethnicity')"
                      />
                    </div>
                  </div>

                  <label class="replacement-label">LGBTQ+ STATUS</label>
                  <div class="form-row hide-label">
                    <div class="col-12">
                      <lgbtq-picker v-model="lgbtq" />
                    </div>
                  </div>

                  <label class="replacement-label">WHAT IS YOUR RELIGION?</label>
                  <div class="form-row hide-label">
                    <div class="col-12">
                      <religion-picker v-model="religion" />
                    </div>
                  </div>

                  <div class="row mt-30">
                    <div class="col-12 col-md-6 order-md-2">
                      <button
                        class="btn btn--primary mt-30"
                        :disabled="saving"
                        type="submit"
                      >
                        <font-awesome-icon
                          v-if="saving"
                          :spin="true"
                          :icon="['fas', 'spinner']"
                          class="icon alt"
                        />
                        <span v-else>Continue</span>
                      </button>
                    </div>
                    <div class="col-12 col-md-6 order-md-1" />
                  </div>
                </form>
              </form-component>
            </card>
          </div>
        </div>

        <div v-show="page === 2" class="login-content text-center">
          <div>
            <card page="login">
              <label v-if="hasSelectedCollege" class="top-label">COMPLETE PROFILE: STEP 2 OF 3</label>
              <label v-else class="top-label">COMPLETE PROFILE: STEP 2 OF 4</label>

              <h1>Office Address Info</h1>
              <form-component>
                <form
                  id="step-two"
                  data-vv-scope="step-two"
                  novalidate="novalidate"
                  @submit.prevent="doSaveWelcomeStepTwo"
                >
                  <input-type-ahead
                    v-if="hasSelectedCollege"
                    v-validate="'required'"
                    :list="colleges"
                    :value="college"
                    :searchchange="getColleges"
                    :selected-value="selectedCollege"
                    placeholder="Search for a College..."
                    label="College"
                    data-vv-name="college"
                    data-vv-as="college"
                    required
                    :error="errors.first('step-two.college')"
                    option-value="id"
                    option-text="display_name"
                  />

                  <input-text
                    v-if="!hasSelectedCollege"
                    id="officeAddress"
                    v-model="officeAddress"
                    v-validate="'required'"
                    name="officeAddress"
                    data-vv-name="officeAddress"
                    data-vv-as="office address"
                    label="Office Address"
                    type="text"
                    required
                    :error="errors.first('step-two.officeAddress')"
                  />

                  <input-text
                    v-if="!hasSelectedCollege"
                    id="city"
                    v-model="city"
                    v-validate="'required'"
                    name="city"
                    data-vv-name="city"
                    data-vv-as="city"
                    label="City"
                    type="text"
                    required
                    :error="errors.first('step-two.city')"
                  />

                  <div v-if="!hasSelectedCollege" class="form-row">
                    <div class="col-12 col-md-6">
                      <label class="replacement-label">STATE</label>
                      <div class="form-row hide-label">
                        <div class="col-12">
                          <input-select
                            id="state"
                            v-model="state"
                            v-validate="'required'"
                            name="state"
                            data-vv-name="state"
                            data-vv-as="state"
                            label="State"
                            type="select"
                            placeholder="Select your state..."
                            required
                            :error="errors.first('step-two.state')"
                            :options="stateOptions"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <input-text
                        id="zip"
                        v-model="zip"
                        v-validate="'required'"
                        name="zip"
                        data-vv-name="zip"
                        data-vv-as="zip"
                        label="Zip Code"
                        type="number"
                        required
                        :error="errors.first('step-two.zip')"
                      />
                    </div>
                  </div>

                  <input-text
                    id="office_number"
                    v-model="office_number"
                    v-validate="'required'"
                    name="office_number"
                    data-vv-name="office_number"
                    data-vv-as="office number"
                    label="Office Phone"
                    type="tel"
                    required
                    :error="errors.first('step-two.office_number')"
                  />

                  <div class="row mt-30">
                    <div class="col-12 col-md-6">
                      <button
                        type="button"
                        class="text-link"
                        @click="goBack(1)"
                      >
                        <span class="forgot-link"> Go Back </span>
                      </button>
                    </div>

                    <div class="col-12 col-md-6">
                      <button
                        class="btn btn--primary mt-30"
                        :disabled="saving"
                        type="submit"
                      >
                        <font-awesome-icon
                          v-if="saving"
                          :spin="true"
                          :icon="['fas', 'spinner']"
                          class="icon alt"
                        />
                        <span v-else>Continue</span>
                      </button>
                    </div>
                    <div class="col-12 col-md-6 order-md-1" />
                  </div>
                </form>
              </form-component>
            </card>
          </div>
        </div>

        <div v-show="page === 3" class="login-content text-center">
          <div>
            <card page="login">
              <label v-if="hasSelectedCollege" class="top-label">COMPLETE PROFILE: STEP 3 OF 3</label>
              <label v-else class="top-label">COMPLETE PROFILE: STEP 3 OF 4</label>

              <h1>Counselor Details</h1>
              <form-component>
                <form
                  id="step-four"
                  data-vv-scope="step-four"
                  novalidate="novalidate"
                  @submit.prevent="doSaveWelcomeStepThree"
                >
                  <div class="row">
                    <div class="col-12">
                      <hr />
                      <div class="photo-preview" style="text-align: center">
                        <div
                          v-if="avatarFileUrl"
                          class="user-avatar"
                          :style="{ backgroundImage: `url(${avatarFileUrl})` }"
                        />
                        <div v-else class="user-avatar" />
                        <h3 style="text-align: left">Profile Photo</h3>
                      </div>
                      <p>
                        Please upload a profile picture of yourself that will be
                        made visible to students.
                      </p>
                    </div>
                    <div class="col-12">
                      <button
                        type="button"
                        class="btn btn-secondary upload-btn"
                        @click="addAvatarFile()"
                      >
                        <span v-if="savingAvatar">
                          <font-awesome-icon
                            :spin="true"
                            :icon="['fas', 'spinner']"
                            class="icon alt"
                          />
                        </span>
                        <span v-else>
                          <font-awesome-icon :icon="['fas', 'upload']" />
                          Upload
                        </span>
                      </button>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="col-12">
                      <hr />
                      <input-text-area
                        id="biography"
                        v-model="biography"
                        v-validate="'required'"
                        name="biography"
                        data-vv-name="biography"
                        data-vv-as="biography"
                        label="Biography"
                        type="text"
                        required
                        :error="errors.first('step-four.biography')"
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="col-12">
                      <label class="replacement-label">SPECIALTIES</label>

                      <treeselect
                        v-if="specialtyOptions && specialtyOptions.length"
                        v-model="specialties"
                        :multiple="true"
                        :options="specialtyOptions"
                        placeholder="Add Specialty"
                      />
                    </div>
                  </div>

                  <div class="row mt-30">
                    <div class="col-12 col-md-6">
                      <button
                        type="button"
                        class="text-link"
                        @click="goBack(2)"
                      >
                        <span class="forgot-link"> Go Back </span>
                      </button>
                    </div>
                    <div class="col-12 col-md-6">
                      <button
                        class="btn btn--primary mt-30"
                        :disabled="saving"
                        type="submit"
                      >
                        <font-awesome-icon
                          v-if="saving"
                          :spin="true"
                          :icon="['fas', 'spinner']"
                          class="icon alt"
                        />
                        <span v-else>Continue</span>
                      </button>
                    </div>
                    <div class="col-12 col-md-6 order-md-1" />
                  </div>

                  <input
                    id="avatarFile"
                    ref="avatarFilePicker"
                    style="display: none"
                    type="file"
                    accept="image/*"
                    name="avatarFile"
                    @change="willAddAvatarFile"
                  />
                </form>
              </form-component>
            </card>
          </div>
        </div>

        <div v-show="page === 4" class="login-content text-center">
          <div>
            <card page="login">
              <upload-documents
                :disabled="saving"
                @back="goBack(3)"
                @submit="doSaveWelcomeStepFour"
              />
            </card>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block col-lg-5 register-right" style="">
        <div>
          <img
            class="forgot__image"
            src="@/assets/img/register-img@2x.png"
            alt="BetterMynd"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import FormComponent from '@/components/FormComponent.vue';
import CounselorEthnicitySelect from './components/CounselorEthnicitySelect.vue';
import GenderSelect from '@/components/inputs/GenderSelect.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';
import UserClient from '@/api/UserClient';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import LgbtqPicker from './components/LgbtqPicker.vue';
import ReligionPicker from './components/ReligionPicker.vue';
import Documents from './documents';
import UploadDocuments from './Welcome/UploadDocuments.vue'
import genderOptions from '@/helpers/mixins/gender-options';

export default {
  name: 'Welcome',
  components: {
    Card,
    Treeselect,
    FormComponent,
    InputSelect,
    InputText,
    InputTextArea,
    InputTypeAhead,
    CounselorEthnicitySelect,
    LgbtqPicker,
    ReligionPicker,
    UploadDocuments,
    GenderSelect
  },
  mixins: [genderOptions],
  provide() {
    return {
      documents: this.documents,
    }
  },

  data() {
    return {
      documents: new Documents(),
      saving: false,
      savingAvatar: false,
      userClient: new UserClient(this.$http),
      page: 1,

      // page one
      month: '',

      day: '',

      year: '',

      gender: '',

      cities: [], // { id, name }
      _getCitiesTimeout: null,
      currentCity: null,

      ethnicity: '',
      lgbtq: '',
      religion: '',

      // page two (both)
      office_number: '',

      // page two only w/o college
      officeAddress: '',
      city: '',
      state: '',
      zip: '',

      // page three

      // photo
      avatarFileUrl: '',
      avatarFile: null,

      biography: '',

      // try tree component here
      specialtyOptions: [],
      specialties: null,

      dayOptions: [
        { id: 1, display_label: '01' },
        { id: 2, display_label: '02' },
        { id: 3, display_label: '03' },
        { id: 4, display_label: '04' },
        { id: 5, display_label: '05' },
        { id: 6, display_label: '06' },
        { id: 7, display_label: '07' },
        { id: 8, display_label: '08' },
        { id: 9, display_label: '09' },
        { id: 10, display_label: '10' },
        { id: 11, display_label: '11' },
        { id: 12, display_label: '12' },
        { id: 13, display_label: '13' },
        { id: 14, display_label: '14' },
        { id: 15, display_label: '15' },
        { id: 16, display_label: '16' },
        { id: 17, display_label: '17' },
        { id: 18, display_label: '18' },
        { id: 19, display_label: '19' },
        { id: 20, display_label: '20' },
        { id: 21, display_label: '21' },
        { id: 22, display_label: '22' },
        { id: 23, display_label: '23' },
        { id: 24, display_label: '24' },
        { id: 25, display_label: '25' },
        { id: 26, display_label: '26' },
        { id: 27, display_label: '27' },
        { id: 28, display_label: '28' },
        { id: 29, display_label: '29' },
        { id: 30, display_label: '30' },
        { id: 31, display_label: '31' }
      ],
      monthOptions: [
        { id: 1, display_label: '01' },
        { id: 2, display_label: '02' },
        { id: 3, display_label: '03' },
        { id: 4, display_label: '04' },
        { id: 5, display_label: '05' },
        { id: 6, display_label: '06' },
        { id: 7, display_label: '07' },
        { id: 8, display_label: '08' },
        { id: 9, display_label: '09' },
        { id: 10, display_label: '10' },
        { id: 11, display_label: '11' },
        { id: 12, display_label: '12' }
      ],
      yearOptions: [],

      stateOptions: [
        { id: 'Alabama', display_label: 'Alabama' },
        { id: 'Alaska', display_label: 'Alaska' },
        { id: 'American Samoa', display_label: 'American Samoa' },
        { id: 'Arizona', display_label: 'Arizona' },
        { id: 'Arkansas', display_label: 'Arkansas' },
        { id: 'California', display_label: 'California' },
        { id: 'Colorado', display_label: 'Colorado' },
        { id: 'Connecticut', display_label: 'Connecticut' },
        { id: 'Delaware', display_label: 'Delaware' },
        { id: 'District of Columbia', display_label: 'District of Columbia' },
        {
          id: 'Federated States of Micronesia',
          display_label: 'Federated States of Micronesia'
        },
        { id: 'Florida', display_label: 'Florida' },
        { id: 'Georgia', display_label: 'Georgia' },
        { id: 'Guam', display_label: 'Guam' },
        { id: 'Hawaii', display_label: 'Hawaii' },
        { id: 'Idaho', display_label: 'Idaho' },
        { id: 'Illinois', display_label: 'Illinois' },
        { id: 'Indiana', display_label: 'Indiana' },
        { id: 'Iowa', display_label: 'Iowa' },
        { id: 'Kansas', display_label: 'Kansas' },
        { id: 'Kentucky', display_label: 'Kentucky' },
        { id: 'Louisiana', display_label: 'Louisiana' },
        { id: 'Maine', display_label: 'Maine' },
        { id: 'Marshall Islands', display_label: 'Marshall Islands' },
        { id: 'Maryland', display_label: 'Maryland' },
        { id: 'Massachusetts', display_label: 'Massachusetts' },
        { id: 'Michigan', display_label: 'Michigan' },
        { id: 'Minnesota', display_label: 'Minnesota' },
        { id: 'Mississippi', display_label: 'Mississippi' },
        { id: 'Missouri', display_label: 'Missouri' },
        { id: 'Montana', display_label: 'Montana' },
        { id: 'Nebraska', display_label: 'Nebraska' },
        { id: 'Nevada', display_label: 'Nevada' },
        { id: 'New Hampshire', display_label: 'New Hampshire' },
        { id: 'New Jersey', display_label: 'New Jersey' },
        { id: 'New Mexico', display_label: 'New Mexico' },
        { id: 'New York', display_label: 'New York' },
        { id: 'North Carolina', display_label: 'North Carolina' },
        { id: 'North Dakota', display_label: 'North Dakota' },
        {
          id: 'Northern Mariana Islands',
          display_label: 'Northern Mariana Islands'
        },
        { id: 'Ohio', display_label: 'Ohio' },
        { id: 'Oklahoma', display_label: 'Oklahoma' },
        { id: 'Oregon', display_label: 'Oregon' },
        { id: 'Palau', display_label: 'Palau' },
        { id: 'Pennsylvania', display_label: 'Pennsylvania' },
        { id: 'Puerto Rico', display_label: 'Puerto Rico' },
        { id: 'Rhode Island', display_label: 'Rhode Island' },
        { id: 'South Carolina', display_label: 'South Carolina' },
        { id: 'South Dakota', display_label: 'South Dakota' },
        { id: 'Tennessee', display_label: 'Tennessee' },
        { id: 'Texas', display_label: 'Texas' },
        { id: 'Utah', display_label: 'Utah' },
        { id: 'Vermont', display_label: 'Vermont' },
        { id: 'Virgin Island', display_label: 'Virgin Island' },
        { id: 'Virginia', display_label: 'Virginia' },
        { id: 'Washington', display_label: 'Washington' },
        { id: 'West Virginia', display_label: 'West Virginia' },
        { id: 'Wisconsin', display_label: 'Wisconsin' },
        { id: 'Wyoming', display_label: 'Wyoming' }
      ],

      // typeahead
      colleges: [], // { id, name, state_code }
      _getCollegesTimeout: null,
      college: null
    };
  },
  computed: {
    hasSelectedCollege() {
      return this.$store.getters.currentUser.counselor_profile
        .on_campus_counselor;
    }
  },
  beforeMount() {
    this.yearOptions = [];
    const maxYears = 100;
    const currentYear = new Date().getFullYear();

    for (let i = 0; i <= maxYears; i++) {
      this.yearOptions.unshift({
        id: currentYear - i,
        display_label: currentYear - i
      });
    }
  },
  async mounted() {
    if (!this.$store.getters.currentUser) { return }
    const user = this.$store.getters.currentUser;

    if (!this.$store.getters.currentUser.needsWelcome) {
      this.$router.push({
        name: this.$store.getters.currentUser.homeRouteName
      });
    }

    await this.documents.initialize(this.$http, user.counselor_profile.id);

    this.avatarFileUrl = user.photo ? user.photo.url : '';

    const all_specialties = await this.userClient.getSpecialtiesList('', 500);

    this.specialtyOptions = (all_specialties.results || []).map((s) => ({
        id: s.id,
        label: s.display_name
      }));

    this.specialties = user.counselor_profile.specialties.map((s) => s.id);

    this.biography = user.counselor_profile.biography || '';

    this.office_number = (user.counselor_profile.office_phone || '').replace(
      '+1',
      ''
    );
    this.officeAddress = user.counselor_profile.street_address || '';
    this.city = user.counselor_profile.locality || '';
    this.state = user.counselor_profile.region || '';
    this.zip = user.counselor_profile.postal_code || '';

    if (user.city) {
      this.currentCity = user.city.id;
      this.cities = [user.city];
    } else {
      this.currentCity = null;
      this.cities = [];
    }

    const parts = user.date_of_birth.split('-');
    if (parts.length === 3) {
      this.day = `${parseInt(parts[2])}`;
      this.month = `${parseInt(parts[1])}`;
      this.year = `${parseInt(parts[0])}`;
    }

    if (user.counselor_profile.school) {
      this.college = user.counselor_profile.school.id;
      this.colleges = [user.counselor_profile.school];
    } else {
      this.college = null;
      this.colleges = [];
    }

    this.gender = user.gender || '';
    this.ethnicity = user.race || '';
    if (user.counselor_profile.lgbtq) this.lgbtq = user.counselor_profile.lgbtq.toString();
    else { this.lgbtq = ''; }
    this.religion = user.counselor_profile.religion || '';

    if (this.specialties.length) {
      if (this.hasSelectedCollege) {
        this.authorizeCalendar();
      } else {
        this.GoToPage(4);
      }
    } else if (
      this.$store.getters.currentUser.counselor_profile.office_phone
    ) {
      this.GoToPage(3); // go to specialties
    } else if (this.$store.getters.currentUser.date_of_birth) {
      this.GoToPage(2); // go to office info
    }
  },
  methods: {
    goBack(page) {
      this.GoToPage(page);
    },
    async doSaveWelcomeStepOne() {
      const result = await this.$validator.validateAll('step-one');
      if (!result) {
        return;
      }
      this.errors.clear();

      const dob = `${this.year}-${
        this.month > 9 ? this.month : `0${this.month}`
      }-${this.day > 9 ? this.day : `0${this.day}`}`;

      try {
        this.saving = true;
        const response = await this.userClient.saveWelcomeStepOne(
          dob,
          this.currentCity,
          this.gender,
          this.ethnicity,
        );
        await this.userClient.saveCounselorProfile({
          lgbtq: this.lgbtq === '' ? null : this.lgbtq,
          religion: this.religion === '' ? null : this.religion,
        });
        this.saving = false;
        const user = this.$store.getters.currentUser;
        user.storeWelcomeStepOneData(response);
        this.$store.commit('setUser', user);
        this.GoToPage(2);
      } catch (ex) {
        this.saving = false;
        let errorMessage = 'Failed to save. Please try again!';

        if (
          ex &&
          ex.body &&
          ex.body.error &&
          ex.body.error.extra &&
          ex.body.error.extra.detail
        ) {
          errorMessage = ex.body.error.extra.detail;
        } else if (ex && ex.body && ex.body.error && ex.body.error.message) {
          errorMessage = ex.body.error.message;
        }

        this.$store.commit('setGlobalAlert', {
          msg: errorMessage,
          error: true
        });
      }
    },
    doSaveWelcomeStepTwo() {
      this.$validator.validateAll('step-two').then((result) => {
        if (result) {
          this.errors.clear();

          const office_phone = this.office_number.replace(/[^\d.]/g, '');

          if (office_phone.length !== 10) {
            return this.$store.commit('setGlobalAlert', {
              msg: 'Please enter your full phone number. For example, (585)123-1234',
              error: true
            });
          }

          const data = {
            office_phone: `+1${office_phone}` // todo: can we not require this ?
          };

          if (this.hasSelectedCollege) {
            if (!this.college) {
              return this.$store.commit('setGlobalAlert', {
                msg: 'Please select your school!',
                error: true
              });
            }

            data.school = this.college;
          } else {
            data.office_address = {
              locality: this.city,
              region: this.state,
              postal_code: this.zip,
              street_address: this.officeAddress
            };
          }

          this.saving = true;
          this.userClient
            .saveCounselorProfile(data)
            .then((response) => {
              this.saving = false;
              const user = this.$store.getters.currentUser;
              user.storeWelcomeCounselorData(response);
              this.$store.commit('setUser', user);
              this.GoToPage(3);
            })
            .catch((ex) => {
              this.saving = false;
              let errorMessage = 'Failed to save. Please try again!';

              if (
                ex &&
                ex.body &&
                ex.body.error &&
                ex.body.error.extra &&
                ex.body.error.extra.detail
              ) {
                errorMessage = ex.body.error.extra.detail;
              } else if (
                ex &&
                ex.body &&
                ex.body.error &&
                ex.body.error.message
              ) {
                errorMessage = ex.body.error.message;
              }

              this.$store.commit('setGlobalAlert', {
                msg: errorMessage,
                error: true
              });
            });
        }
      });
    },

    doSaveWelcomeStepThree() {
      this.$validator.validateAll('step-three').then((result) => {
        if (result) {
          this.errors.clear();

          if (!this.avatarFileUrl || !this.avatarFileUrl.length) {
            return this.$store.commit('setGlobalAlert', {
              msg: 'Please upload a photo!',
              error: true
            });
          }

          if (!this.specialties.length) {
            return this.$store.commit('setGlobalAlert', {
              msg: 'Please enter your specialties!',
              error: true
            });
          }

          if (!this.biography) {
            return this.$store.commit('setGlobalAlert', {
              msg: 'Please enter your biography',
              error: true
            });
          }

          this.saving = true;
          const data = {
            biography: this.biography,
            specialty_ids: this.specialties,
          };

          this.userClient
            .saveCounselorProfile(data)
            .then((response) => {
              this.saving = false;
              const user = this.$store.getters.currentUser;
              user.storeWelcomeCounselorData(response);
              this.$store.commit('setUser', user);
              if (this.hasSelectedCollege) {
                this.authorizeCalendar();
              } else {
                this.GoToPage(4);
              }
            })
            .catch((ex) => {
              this.handleSaveException(ex);
              this.saving = false;
            });
        }
      });
    },

    async doSaveWelcomeStepFour(docs) {
      try {
        this.saving = true;

        const { governmentId, insurance, license } = docs;

        await this.documents.setGovernmentId(governmentId.file);
        await this.documents.setInsurance(insurance.file);
        await this.documents.addLicense(
          license.type,
          license.usState,
          license.licenseNumber,
          license.expires,
          license.file);

        await this.resetUser();
        this.authorizeCalendar();
      } catch (ex) {
        this.handleSaveException(ex);
      } finally {
        this.saving = false;
      }
    },
    handleSaveException(ex) {
      console.error(ex)
      let errorMessage = 'Failed to save. Please try again!';

      if (ex && ex.body && ex.body.error) {
 if (ex.body.error.extra && ex.body.error.extra.detail) errorMessage = ex.body.error.extra.detail;
        else if (ex.body.error.message) errorMessage = ex.body.error.message;
}

      this.$store.commit('setGlobalAlert', {
        msg: errorMessage,
        error: true
      });
    },
    async resetUser() {
      const user = await this.userClient.getRemoteUser();
      this.$store.commit('setUser', user);
    },
    GoToPage(page) {
      this.page = page;
      this.errors.clear();
      this.$validator.reset();
    },

    getCities(query, done) {
      if (this.currentCity && !query) {
        // we just selected one, do not empty the results
        return;
      }

      if (this._getCitiesTimeout) {
        clearTimeout(this._getCitiesTimeout);
        this._getCitiesTimeout = null;
      }

      this._getCitiesTimeout = setTimeout(() => {
        this.userClient
          .getCityList(query)
          .then((cities) => {
            this.cities = cities.results || [];
          })
          .catch(() => {
            this.cities = [];
          });
      }, 300);
    },
    selectedCity(v) {
      this.currentCity = v;
    },

    // files
    async willAddMalpractice(event) {
      const files = event.target.files || [];
      this.malPracticeFile = files.length ? files[0] : null;
    },
    async willAddCounselingCert(event) {
      const files = event.target.files || [];
      this.counselingCertFile = files.length ? files[0] : null;
    },
    async willAddGovPhotoID(event) {
      const files = event.target.files || [];
      this.govPhotoIDFile = files.length ? files[0] : null;
    },

    // typeahead
    getColleges(query, done) {
      if (this.college && !query) {
        // we just selected one, do not empty the results
        return;
      }

      if (this._getCollegesTimeout) {
        clearTimeout(this._getCollegesTimeout);
        this._getCollegesTimeout = null;
      }

      this._getCollegesTimeout = setTimeout(() => {
        this.userClient
          .getCollegeList(query)
          .then((colleges) => {
            this.college = null;
            this.colleges = colleges.results || [];
          })
          .catch(() => {
            this.college = null;
            this.colleges = [];
          });
      }, 300);
    },
    selectedCollege(v) {
      this.college = v;
    },
    async authorizeCalendar() {
      await this.$router.push({ name: 'availability' });
    },

    // photo
    addAvatarFile() {
      this.$refs.avatarFilePicker.click();
    },

    async willAddAvatarFile(event) {
      const files = event.target.files || [];
      const avatarFile = files.length ? files[0] : null;

      if (avatarFile) {
        this.savingAvatar = true;

        try {
          const avatarPhotoMeta = await this.userClient.getSignedUploadUrl();
          await UserClient.saveFile(avatarPhotoMeta.signed_url, avatarFile);

          const savedUser = await this.userClient.saveProfilePhoto(
            avatarPhotoMeta.id
          );
          const user = this.$store.getters.currentUser;
          user.photo = savedUser.photo;

          this.avatarFile = savedUser.photo.id;
          this.avatarFileUrl = savedUser.photo.url;

          this.$store.commit('setUser', user);
          this.savingAvatar = false;
        } catch (ex) {
          console.log(ex);
          this.$store.commit('setGlobalAlert', {
            msg: 'Failed to save file. Please try again!',
            error: true
          });
          this.avatarFile = null;
          this.savingAvatar = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-left,
.login-right,
.login-content,
.register-right {
  @media (min-width: $md-min) {
    height: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
    min-height: 800px;
  }
}

.register-right {
  padding-top: 0;
  padding-bottom: 0;
}

.login__card {
  overflow: visible;
}

.login-content {
  min-height: 700px;
}

.form__error {
  color: $red !important;
}

.register {
  p {
    color: rgba(white, 0.75);
  }

  .register-right {
    text-align: center;
    padding-left: 0;
    padding-right: 0;
    overflow: hidden;

    @media (min-width: $lg-min) {
      text-align: left;
      min-height: 100vh;
      max-height: 100vh;
      background: rgb(42, 122, 161);
      background:
        linear-gradient(
          180deg,
          rgba(42, 122, 161, 1) 0%,
          rgba(40, 102, 159, 1) 100%
        );
      position: sticky;
      top: 0;
    }

    img {
      width: 100%;
      height: auto;
      position: relative;
      z-index: 2;
      left: 0;

      @media (max-width: $md-max) {
        left: auto;
        right: auto;
        width: 75%;
        margin: 0 auto;
      }
    }
  }

  .top-label {
    color: $green;
    font-size: 12px;
    letter-spacing: 0.1rem;
  }

  a.green {
    color: $green;
  }

  ::v-deep .replacement-label {
    text-transform: uppercase;
    font-size: 10px;
    opacity: 0.75;
    letter-spacing: 0.1rem;
    margin-bottom: 5px;
  }
}

.photo-preview {
  .user-avatar {
    @include background-cover;
    @include border-radius(100px);

    background-image: url('~@/assets/img/default-user.jpg');
    height: 80px;
    width: 80px;
    margin-right: 15px;
    display: inline-block;
    vertical-align: top;
    margin-bottom: 15px;
  }
}

::v-deep .vue-treeselect__menu {
  color: #000;
}
</style>
